import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import React, { memo } from "react";
import { Box } from "./Box";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
export const avatarListClasses = {
    root: "MinervaAvatarList-root",
    avatar: "MinervaAvatarList-avatar",
};
export const AvatarList = memo((props) => {
    const { children, overlap = 1, size = "md", className, sx, ...rest } = useDefaultProps({ component: "AvatarList", props });
    const childrenArray = React.Children.toArray(children);
    const sizing = {
        xxs: 6,
        xs: 7,
        sm: 8,
        md: 10,
        lg: 14,
        xl: 18,
    };
    return (_jsx(Box, { className: clsx([avatarListClasses.root, className]), sx: mergeSx({
            position: "relative",
            display: "flex",
            alignItems: "center",
            [`& .${avatarListClasses.avatar}`]: {
                marginLeft: 0,
                border: 1,
                borderColor: (theme) => theme.palette.background.main,
                width: typeof size === "number" ? size : sizing[size],
                height: typeof size === "number" ? size : sizing[size],
            },
            [`& > .${avatarListClasses.avatar} ~ .${avatarListClasses.avatar}`]: {
                marginLeft: -overlap,
            },
        }, sx), ...rest, children: childrenArray?.map((avatar, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
        _jsx(React.Fragment, { children: avatar }, i))) }));
});
//# sourceMappingURL=AvatarList.js.map